// assets/favorites.js - FINAL version (no more duplication loops)

let favoritesRendered = false; // Guard to prevent double rendering

document.addEventListener('DOMContentLoaded', () => {
  console.log('favorites.js loaded successfully');

  // ────────────────────────────────────────────────
  // PART 1: Heart button logic (runs on every page with cards)
  // ────────────────────────────────────────────────
  const favoriteButtons = document.querySelectorAll('.favorites-btn');

  console.log('Found favorite buttons:', favoriteButtons.length);

    // ────────────────────────────────────────────────
    // PART 1: Heart button logic – delegation to catch late/dynamic buttons
    // ────────────────────────────────────────────────
    document.addEventListener('click', function(e) {
      const button = e.target.closest('.favorites-btn');
      if (!button) return;

      e.stopPropagation();
      e.preventDefault();

      const productId = button.dataset.productId;
      if (!productId) {
        console.warn('favorites-btn clicked but missing data-product-id');
        return;
      }

      // Prefer data attrs (you should add these to the main product button markup)
      let productHandle = button.dataset.productHandle || 'unknown';
      let productTitle  = button.dataset.productTitle  || 'unknown';

      // Fallback scrape for cards if attrs missing
      if (productHandle === 'unknown' || productTitle === 'unknown') {
        const linkElem = button.closest('.card, .card-wrapper')?.querySelector('.card__heading a, .full-unstyled-link');
        if (linkElem) {
          productHandle = linkElem.href.split('/products/')[1]?.split('?')[0] || 'unknown';
          productTitle  = linkElem.textContent.trim() || 'unknown';
        }
      }

      const willBeActive = !button.classList.contains('active');

      button.classList.toggle('active');
      const svg = button.querySelector('svg');
      if (svg) {
        if (willBeActive) {
          svg.setAttribute('fill', 'red');
          svg.setAttribute('stroke', 'red');
        } else {
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
        }
      } else {
        console.warn('No SVG found in button for ID:', productId);
      }

      let favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
      if (willBeActive) {
        favorites = favorites.filter(f => f.id !== productId); // your dedupe
        favorites.push({ id: productId, handle: productHandle, title: productTitle });
        showToast('Added to favorites!');
      } else {
        favorites = favorites.filter(f => f.id !== productId);
        showToast('Removed from favorites.');
      }
      localStorage.setItem('favorites', JSON.stringify(favorites));

      trackFavoriteEvent(productId, productHandle, productTitle, willBeActive ? 'add' : 'remove');

      if (!Shopify.customer && willBeActive && !localStorage.getItem('favorite_nudge_shown')) {
        showToast('Saved to your favorites! Log in to keep them on all your devices.');
        localStorage.setItem('favorite_nudge_shown', 'true');
      }

      updateFavoritesCount();
    });

    // ────────────────────────────────────────────────
    // Restore visual state — reusable function for initial + late-loaded buttons
    // ────────────────────────────────────────────────
    function restoreFavoritesState() {
      const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
      const favIds = new Set(favorites.map(f => String(f.id)));
      const buttons = document.querySelectorAll('.favorites-btn');

      buttons.forEach(button => {
        const productId = String(button.dataset.productId);
        if (!productId) return;
        const isFav = favIds.has(productId);

        button.classList.toggle('active', isFav);
        const svg = button.querySelector('svg');
        if (svg) {
          svg.setAttribute('fill', isFav ? 'red' : 'none');
          svg.setAttribute('stroke', isFav ? 'red' : 'currentColor');
        }
      });

      console.debug('[favorites] State restored on', buttons.length, 'buttons');
    }

    // Run immediately
    restoreFavoritesState();

    // Also run after short delay for AJAX-loaded related/complementary products
    setTimeout(restoreFavoritesState, 1500);

    // MutationObserver: catch any dynamically added buttons (section rendering API, etc.)
    const _favObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length) {
          const hasNewBtn = [...m.addedNodes].some(
            n => n.nodeType === 1 && (n.matches?.('.favorites-btn') || n.querySelector?.('.favorites-btn'))
          );
          if (hasNewBtn) {
            console.debug('[favorites] New button detected via MutationObserver');
            restoreFavoritesState();
          }
        }
      }
    });
    _favObserver.observe(document.body, { childList: true, subtree: true });

  // ────────────────────────────────────────────────
  // PART 2: Render favorites on /pages/favorites (only once)
  // ────────────────────────────────────────────────
  const container = document.getElementById('favorites-container');
  const noFavoritesMsg = document.getElementById('no-favorites');

  if (container && !favoritesRendered) {
    favoritesRendered = true; // Prevent double-run on reloads

    console.log('Rendering favorites page');

    container.innerHTML = ''; // Clear EVERY time

    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');

    if (favorites.length === 0) {
      noFavoritesMsg.classList.remove('hidden');
      return;
    }

    favorites.forEach(async (fav) => {
      const productHandle = fav.handle;

      if (!productHandle) {
        console.warn('Favorite entry missing handle:', fav);
        return;
      }

      try {
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) {
          console.warn(`Product handle ${productHandle} (ID ${fav.id}) not found (404) — skipping`);
          return;
        }
        const product = await response.json();

        console.log('Loaded product:', product.title, 'Image src:', product.featured_image?.src);

        const cardHTML = `
          <li class="grid__item">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard">
                <div class="card__inner ratio">
                  <div class="card__media">
                    <div class="media media--transparent">
                      <a href="/products/${product.handle}" class="full-unstyled-link">
                        <img
                          src="${product.featured_image}"
                          alt="${product.title}"
                          loading="lazy"
                          class="motion-reduce"
                        >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5">
                      <a href="/products/${product.handle}" class="full-unstyled-link">
                        ${product.title}
                      </a>
                    </h3>
                    <div class="card-information">
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        `;

        container.insertAdjacentHTML('beforeend', cardHTML);
      } catch (err) {
        console.error('Failed to load product handle:', productHandle, err);
      }
    });

    // Remove button functionality (uses handle for removal)
    document.querySelectorAll('.remove-favorite-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        const productHandle = btn.dataset.productHandle;  // ← Use handle here
        if (!productHandle) {
          console.warn('Remove button missing handle');
          return;
        }

        // Remove from stored favorites
        let favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
        favorites = favorites.filter(fav => fav.handle !== productHandle);
        localStorage.setItem('favorites', JSON.stringify(favorites));

        // Re-render the list
        container.innerHTML = '';  // Clear old cards
        favorites.forEach(async (fav) => {
          const productHandle = fav.handle;

          if (!productHandle) {
            console.warn('Favorite entry missing handle:', fav);
            return;
          }

          try {
            const response = await fetch(`/products/${productHandle}.js`);
            if (!response.ok) {
              console.warn(`Product handle ${productHandle} (ID ${fav.id}) not found (404) — skipping`);
              return;
            }
            const product = await response.json();

            console.log('Loaded product:', product.title, 'Image src:', product.featured_image?.src);

            const cardHTML = `
              <li class="grid__item">
                <div class="card-wrapper product-card-wrapper underline-links-hover">
                  <div class="card card--standard">
                    <div class="card__inner ratio">
                      <div class="card__media">
                        <div class="media media--transparent">
                          <a href="/products/${product.handle}" class="full-unstyled-link">
                            <img
                              src="${product.featured_image}"
                              alt="${product.title}"
                              loading="lazy"
                              class="motion-reduce"
                            >
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="card__content">
                      <div class="card__information">
                        <h3 class="card__heading h5">
                          <a href="/products/${product.handle}" class="full-unstyled-link">
                            ${product.title}
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            `;

            container.insertAdjacentHTML('beforeend', cardHTML);
          } catch (err) {
            console.error('Failed to load product handle:', productHandle, err);
          }
        });

        showToast('Removed from favorites.');
        updateFavoritesCount();

        if (favorites.length === 0) {
          noFavoritesMsg.classList.remove('hidden');
        }
      });
    });
  }

  updateFavoritesCount();

  // ────────────────────────────────────────────────
  // Full product card clickability fallback – delegated, safe for all pages
  // ────────────────────────────────────────────────
  function enableProductCardNavigation() {
    document.addEventListener('click', function(e) {
      // Skip if click originated on interactive element (heart, buttons, links, etc.)
      if (e.target.closest('.favorites-btn, a, button, input, select, [role="button"], [tabindex="0"]')) {
        return;
      }

      // Skip PDP product info/media areas UNLESS the click is on a complementary product card
      if (e.target.closest('.product__info-wrapper, .product__media-wrapper, product-info')) {
        if (!e.target.closest('.complementary-products, .complementary-slide')) {
          return;
        }
      }

      const card = e.target.closest('.card-wrapper, .card, .grid__item, .product-card-wrapper');
      if (!card) return;

      const link = card.querySelector('.full-unstyled-link, a[href^="/products/"]');
      if (link && link.href && link.href !== window.location.href) {
        e.preventDefault();
        window.location.href = link.href;
      }
    }, { passive: false });
  }

  // Run immediately
  enableProductCardNavigation();

  // Re-run after delay to catch late-loaded cards (related products, infinite scroll, etc.)
  setTimeout(enableProductCardNavigation, 1500);
  setTimeout(enableProductCardNavigation, 3000);  // extra safety net
});

// ────────────────────────────────────────────────
// Helpers
// ────────────────────────────────────────────────

function showToast(message) {
  const toast = document.createElement('div');
  toast.textContent = message;
  toast.style.cssText = `
    position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%);
    background: #2C9EA0; color: white; padding: 12px 24px; border-radius: 8px;
    z-index: 1000; opacity: 0; transition: opacity 0.4s;
  `;
  document.body.appendChild(toast);
  setTimeout(() => toast.style.opacity = '1', 10);
  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => toast.remove(), 400);
  }, 3000);
}

function updateFavoritesCount() {
  const countElement = document.getElementById('favorites-count');
  if (!countElement) return;

  const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
  countElement.textContent = `(${favorites.length})`;
}

function trackFavoriteEvent(productId, productHandle, productTitle, action) {
  if (window.gtag) {
    const eventName = action === 'add' ? 'add_to_favorites' : 'remove_from_favorites';

    const params = {
      product_id: productId,
      product_handle: productHandle,
      product_title: productTitle,
      user_type: Shopify.customer ? 'logged_in' : 'guest',
    };

    // Add customer ID only for logged-in users (safe, non-PII)
    if (Shopify.customer?.id) {
      params.customer_id = Shopify.customer.id;           // numeric ID
      // or: ShopifyAnalytics?.meta?.page?.customerId   // sometimes string
    }

    gtag('event', eventName, params);

    console.log('GA4 event tracked:', eventName, params);
  } else {
    console.log('GA4 not detected — event not sent');
  }
}